import { gql } from '@apollo/client';

export const USERS = gql`
  query fetchUsers(
    $filter: UserFilterInputType
    $pagination: PaginationInputType
    $orderBy: UserOrderByWithRelationInput
  ) {
    fetchUsers(filter: $filter, pagination: $pagination, orderBy: $orderBy) {
      users {
        id
        username
        firstName
        lastName
        email
        phone
        totalPoints
        isNotificationEnabled
        membershipType
        isEmailVerified
        isPhoneVerified
        regionCity
        regionCountry
        # Ban state, so a banned member is marked here rather than looking
        # ordinary. fetchUsers applies no isDeleted filter, so banning somebody
        # does not remove their row — without these fields the screen would show
        # a live-looking account that is refused on every operation.
        isBanned
        isDeleted
        bannedAt
        banReason
        bannedBy
        City {
          name
        }
        Country {
          name
        }
        State {
          name
        }
        ReferredByReferral {
          RefferedByUser {
            firstName
            lastName
            username
          }
        }
        Referrals {
          id
        }
        BusinessRecommendations {
          id
        }
      }
      total
    }
  }
`;

export const USER_DETAILS = gql`
  query fetchUserDetails($id: Int!) {
    fetchUserDetails(id: $id) {
      id
      uid
      username
      firstName
      lastName
      email
      phone
      userLevel
      gender
      totalPoints
      membershipType
      streetAddress
      tShirtSize
      role
      regionCity
      regionState
      regionStateCode
      regionCountry
      regionCountryCode
      ambassador
      ProfileImage {
        url
      }
    }
  }
`;

export const COUNTRY_FILTER_AUTOCOMPLETE = gql`
  query countryAutocomplete($filter: String) {
    getCountriesAutocomplete(filter: $filter) {
      regionCountry
    }
  }
`;

export const STATE_FILTER_AUTOCOMPLETE = gql`
  query stateFilterAutocomplete($filter: String) {
    getStatesAutocomplete(filter: $filter) {
      regionState
      regionCountry
    }
  }
`;

export const CITY_FILTER_AUTOCOMPLETE = gql`
  query cityFilterAutocomplete($filter: String) {
    getCitiesAutocomplete(filter: $filter) {
      regionCity
      regionState
      regionCountry
    }
  }
`;

export const CITY_GOOGLE_PLACE_AUTOCOMPLETE = gql`
  query cityGooglePlaceAutocomplete($filter: String) {
    getCitiesGooglePlaceAutocomplete(filter: $filter) {
      placeId
      description
    }
  }
`;

export const FETCH_CITY_GOOGLE_PLACE = gql`
  query fetchCityGooglePlace($placeId: String!) {
    fetchCityGooglePlace(placeId: $placeId) {
      regionCity
      regionState
      regionStateCode
      regionCountry
      regionCountryCode
    }
  }
`;

export const USER_FIELDS = gql`
  query {
    fetchUserFields {
      fields {
        name
        type
        kind
        isReference
      }
    }
  }
`;

export const SEARCH_USERS = gql`
  query searchUsers($filter: String!) {
    searchUsers(query: $filter) {
      username
      firstName
      lastName
    }
  }
`;